import noUiSlider from 'nouislider'

export default function rangeSlider(config = {}) {
  return {
    value: config.start ?? config.min ?? 0,
    slider: null,
    config: {
      min: config.min ?? 0,
      max: config.max ?? 100,
      start: config.start ?? config.min ?? 0,
      step: config.step ?? 1,
    },

    init() {
      this.$nextTick(() => {
        this.createSlider()
        Alpine.effect(() => {
          if (this.value !== undefined && this.slider.get() != this.value) {
            this.slider.set(this.value)
          }
        })
      })
    },

    createSlider() {
      const sliderEl = this.$refs.slider
      if (!sliderEl) return

      this.slider = noUiSlider.create(sliderEl, {
        start: [this.config.start],
        connect: [true, false],
        step: this.config.step,
        range: {
          min: this.config.min,
          max: this.config.max,
        },
      })

      this.slider.on('update', (values) => {
        this.value = Math.round(parseFloat(values[0]))
      })

      this.$watch('value', (newValue) => {
        console.log('newValue', newValue)
        const currentValue = Math.round(parseFloat(this.slider.get()))
        if (currentValue !== newValue) {
          this.slider.set(newValue)
        }
      })
    },

    formatValue(val) {
      return new Intl.NumberFormat('ro-RO').format(val)
    },

    destroy() {
      if (this.slider) {
        this.slider.destroy()
        this.slider = null
      }
    },
  }
}

